import type { IUser } from '@/api/routes/users/types';
import { ROLES } from '@/api/routes/users/types';

export default (
  requiredRoles: ROLES[],
  user: IUser | null,
  isStrict?: boolean,
  additionalRequiredRoles: ROLES[] = [],
) => {
  if (!user) return false;

  const userRolesId = user?.roles.map((role) => role.id) || [];
  const isAdmin = userRolesId.includes(ROLES.ADMIN);
  const someRoleMatch = isStrict ? requiredRoles.every((role) => userRolesId.includes(role))
    : requiredRoles.some((role) => userRolesId.includes(role));

  const isAdditionalRoles = additionalRequiredRoles.every((role) => userRolesId.includes(role));

  if (additionalRequiredRoles.length) {
    return isAdmin || someRoleMatch || isAdditionalRoles;
  }

  return isAdmin || someRoleMatch;
};
